export class MarketingTotal {
    totalLeads: number;
    contactedLeads: number;
    totalVisits: number;
    visitedLeads: number;
    closedLeads: number;
    archivedLeads: number;
    onTrackLeads: number;
    unassignedLeads: number;
    newLeads: number;
    expiredLeads: number;

}
